import { CarrierSubmission, CarrierSubmissionUpdate } from 'types';
import { HttpMethods } from 'utils/http';
import { CapitolaClient } from './base';

export default class CarrierSubmissionClient extends CapitolaClient<CarrierSubmission> {
  public get resourceName(): string {
    return 'carrier-submission';
  }

  public async updateCarrierSubmission(id: string, data: CarrierSubmissionUpdate): Promise<CarrierSubmission | null> {
    return this.custom<CarrierSubmission>({
      httpMethod: HttpMethods.PATCH,
      path: id,
      body: data,
      fetchOptions: { throwOnError: true },
    });
  }
}
